import { Directive, ElementRef, Input, OnInit, Renderer2, Inject, HostBinding, HostListener, DOCUMENT } from '@angular/core';
import { UserSessionService } from '../services/usersession.service';
import { EActionTypes, EElementTypes } from './enum';
@Directive({
    selector: '[permissionHandler]',
    standalone: false
})
export class PermissionHandlerDirective implements OnInit {
    @Input() moduleId: number;
    @Input() functId: number;
    @Input() action: number;
    @Input() elementType: number;
    userRights;
    enumActionType = EActionTypes;
    enumElementType = EElementTypes;
    constructor(private elementRef: ElementRef,
        private renderer: Renderer2,
        private userSessionData: UserSessionService,
        @Inject(DOCUMENT) private document) {
    }
    ngOnInit() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation: MutationRecord) => {
                if (mutation.type == "attributes" && mutation.attributeName == "disabled") {
                    this.changeHost();
                }
            });
        });
        observer.observe(this.elementRef.nativeElement, {
            attributes: true,
            childList: true,
            characterData: true
        });
        this.userRights = this.userSessionData.getUserRights(this.functId);
        this.changeHost();
    }

    changeHost() {
        if (this.elementType === this.enumElementType.BUTTON) {
            if ((this.userRights == null || !this.userRights.CreateRight) && this.action == this.enumActionType.CREATE) {
                if (!this.elementRef.nativeElement.getAttribute('disabled')) {
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'title', 'You do not have rights to create!');
                }
            }
            if ((this.userRights == null || !this.userRights.EditRight) && this.action == this.enumActionType.EDIT) {
                if (!this.elementRef.nativeElement.getAttribute('disabled')) {
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'title', 'You do not have rights to Edit!');
                }
            }
            if ((this.userRights == null || !this.userRights.DeleteRight) && this.action == this.enumActionType.DELETE) {
                if (!this.elementRef.nativeElement.getAttribute('disabled')) {
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'title', 'You do not have rights to Delete!');
                }
            }
            if ((this.userRights == null || !this.userRights.ViewRight) && this.action == this.enumActionType.VIEW) {
                if (!this.elementRef.nativeElement.getAttribute('disabled')) {
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'title', 'You do not have rights to View!');
                }
            }

        }
        if (this.elementType === this.enumElementType.DIV) {
            if ((this.userRights == null || !this.userRights.ViewRight) && this.action == this.enumActionType.VIEW) {
                this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
                const child = document.createElement('div');
                child.classList.add('viewRightCls');
                child.innerHTML = 'You do not have rights to view!';
                let parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
                parentNode.appendChild(child);
            }
        }
        if (this.elementType === this.enumElementType.INPUT) {
            if ((this.userRights == null || !this.userRights.EditRight) && this.action == this.enumActionType.EDIT) {
                if (!this.elementRef.nativeElement.getAttribute('disabled')) {
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
                    this.renderer.setAttribute(this.elementRef.nativeElement, 'title', 'You do not have rights to edit!');
                }
            }
        }
    }

}


